// Strings that must not be translated. Merged into IntlProvider messages
// at runtime so they're available via useIntl/FormattedMessage but never
// sent to Crowdin.
const fixedStrings: Record<string, string> = {
  createai: "CreateAI",
  "event-format-streamyard": "StreamYard",
  "event-format-teams": "Microsoft Teams",
  "event-format-youtube": "YouTube",
  "event-format-zoom": "Zoom",
  makecode: "MakeCode",
  python: "Python",
  "python-editor": "Python Editor",
  scratch: "Scratch",
  "take-up-a-challenge": "Take up a challenge"
};

export default fixedStrings;
